module.exports = __webpack_public_path__ + "static/media/tools-pen.c0624959.svg";